import english from "./english.json";
import hindi from "./hindi.json";
import urdu from "./urdu.json";

const translate = (publisherName, name) => {
  switch (publisherName) {
    case "en":
      return english[name];
    case "hi":
      return hindi[name];
    case "ur":
      return urdu[name];
    default:
      return english[name];
  }
};

export default translate;
